import {useOpenedStateManager} from '@aboutyou/opened-state-manager';
import {WalletType} from './useActiveTab';

export const WALLET_STATE_MANAGER_PARAM = 'wallet';
const WALLET_STATE_MANAGER_KEY = 'WALLET_STATE_MANAGER_KEY';

export const useWalletStateManager = () => {
  const allowedValues: WalletType[] = [
    'coupons',
    'coins',
    'notificationCenter',
  ];

  const {cancel, isOpen, open, hide} = useOpenedStateManager(
    WALLET_STATE_MANAGER_KEY,
    {
      controlParams: [
        {urlSearchParam: WALLET_STATE_MANAGER_PARAM, allowedValues},
      ],
    },
  );

  const openWallet = (walletType: WalletType) => {
    open({parameter: walletType});
  };

  return {cancel, isOpen, open: openWallet, hide};
};
